import { render } from "@/share/components/pages/maintenanceError/MaintenanceError.html?vue&type=template&id=21afe1c6&scoped=true&external"
import script from "@/share/components/pages/maintenanceError/MaintenanceError.js?vue&type=script&lang=js&external"
export * from "@/share/components/pages/maintenanceError/MaintenanceError.js?vue&type=script&lang=js&external"

import "@/share/components/pages/maintenanceError/MaintenanceError.scss?vue&type=style&index=0&id=21afe1c6&lang=scss&scoped=true&external"

import exportComponent from "../../../../execute/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21afe1c6"]])

export default __exports__